"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzChartCalendar__Wrapper",
  componentId: "sc-1pnply4-0"
})(["\n  width: 100%;\n  height: 100%;\n  height: ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  background-color: #fff;\n\n\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.height;
});

var Grid = _styledComponents.default.div.withConfig({
  displayName: "OzChartCalendar__Grid",
  componentId: "sc-1pnply4-1"
})(["\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-gap: 5px;\n  width: 100%;\n  height: 100%;\n\n"]);

var Day = _styledComponents.default.div.withConfig({
  displayName: "OzChartCalendar__Day",
  componentId: "sc-1pnply4-2"
})(["\n  grid-column: ", " / span 1;\n  grid-row: ", " / span 1;\n  text-align: center;\n  min-height: 10px;\n  line-height: 0px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  color: #303030;\n\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], function (props) {
  return props.col;
}, function (props) {
  return props.row;
}, function (props) {
  return props.type === "val" ? "\n    background: " + props.color + props.opacity + ";\n  " : null;
}, function (props) {
  return props.type === "header" ? "\n    font-size: 9px;\n\n    & b{\n      font-weight: 700;\n      text-decoration: underline;\n    }\n  " : null;
}, function (props) {
  return props.type === "past" ? "\n  " : null;
}, function (props) {
  return props.type === "today" ? "\n    background: #C0EFD1;\n    border-radius: 20px;\n  " : null;
}, function (props) {
  return props.type === "future" ? "\n\n    &::after{\n      content: \"\";\n      display: inline-block;\n      width: 100%;\n      height: 0px;\n      border-bottom: 3px dotted #D8D8D8;\n    }\n  " : null;
});

var OzChartCalendar = function OzChartCalendar(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? "300px" : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#687fe2" : _ref$color,
      _ref$minOpacity = _ref.minOpacity,
      minOpacity = _ref$minOpacity === void 0 ? 0.2 : _ref$minOpacity,
      _ref$maxOpacity = _ref.maxOpacity,
      maxOpacity = _ref$maxOpacity === void 0 ? 1 : _ref$maxOpacity,
      _ref$dateStart = _ref.dateStart,
      dateStart = _ref$dateStart === void 0 ? null : _ref$dateStart,
      _ref$dateEnd = _ref.dateEnd,
      dateEnd = _ref$dateEnd === void 0 ? null : _ref$dateEnd,
      _ref$maxVal = _ref.maxVal,
      maxVal = _ref$maxVal === void 0 ? null : _ref$maxVal,
      values = _ref.values,
      fnCallback = _ref.fnCallback;
  dateStart = dateStart ? dateStart : values.map(function (item) {
    return item.date;
  }).reduce(function (a, b) {
    return a < b ? a : b;
  });
  var dateWeekStart = new Date(dateStart.getTime());
  dateWeekStart.setDate(dateStart.getDate() + 1 - (dateStart.getDay() === 0 ? 7 : dateStart.getDay()));
  dateEnd = dateEnd ? dateEnd : values.length ? values.map(function (item) {
    return item.date;
  }).reduce(function (a, b) {
    return a > b ? a : b;
  }) : null;
  maxVal = maxVal ? maxVal : values.length ? values.map(function (item) {
    return item.value;
  }).reduce(function (a, b) {
    return a > b ? a : b;
  }) : null;
  var rangeOpacity = maxOpacity - minOpacity;
  var allDays = [];
  dateStart = new Date(dateStart.setUTCHours(0, 0, 0, 0));
  dateEnd = new Date(dateEnd.setUTCHours(23, 59, 59, 999));

  for (var d = new Date(new Date(dateStart.getTime()).setUTCHours(0, 0, 0, 0)); d <= dateEnd; d.setDate(d.getDate() + 1)) {
    // console.log(new Date(d));
    allDays.push(new Date(d));
  }

  return __jsx(Wrapper, {
    height: height
  }, __jsx(Grid, null, ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"].map(function (day, i) {
    return __jsx(Day, {
      key: i,
      col: i + 1,
      row: 1,
      type: "header"
    }, i === (new Date().getDay() === 0 ? 7 : new Date().getDay()) - 1 ? __jsx("b", null, day) : day);
  }), allDays.map(function (date, i) {
    return __jsx(Day, {
      key: i,
      col: date.getDay() === 0 ? 7 : date.getDay(),
      row: Math.floor(Math.floor(Math.floor(date - dateWeekStart) / (24 * 60 * 60 * 1000)) / 7) + 2,
      type: date <= new Date() ? date.getDate() === new Date().getDate() && date.getMonth() === new Date().getMonth() ? "today" : "past" : "future"
    });
  }), values.map(function (item, i) {
    return item.value !== null ? __jsx(Day, {
      key: i,
      col: item.date.getDay() === 0 ? 7 : item.date.getDay(),
      row: Math.floor(Math.floor(Math.floor(item.date - dateWeekStart) / (24 * 60 * 60 * 1000)) / 7) + 2,
      type: "val",
      color: color,
      opacity: Math.floor((item.value * rangeOpacity / maxVal + minOpacity) * 255).toString(16)
    }) : null;
  })));
};

var _default = OzChartCalendar;
exports.default = _default;